import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=2571cabe"
import script from "./SectionCard.vue?vue&type=script&lang=ts"
export * from "./SectionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports